export const bootUrl = '/boot.json';
export const REACT_APP_BOOT_URL = '/boot.json';
export const REACT_APP_DUMP_URL = '/session/dump.json';
export const NOTIFICATION_PATH = '/rqx/api/eds/v1/notifications/token';
export const NOTIFICATION_READ_PATH = '/rqx/web/notification/mark-read';
export const FAQ_VIDEO_PATH = '/cms/faq/';
/** Probe GET `{api.baseUrl}/api/features/qrcode/{appCode}` (payload login mobile / QR Kairos). */
export const FEATURES_QR_CODE_PATH = '/api/features/qrcode/';
/** GET `{api.baseUrl}/api/features/nps/{appCode}` (eligibility NPS autenticata; `baseUrl` include già il contesto /rqx). */
export const FEATURES_NPS_PATH = '/api/features/nps/';
/** POST `{api.baseUrl}/api/features/nps/{appCode}/submission` (invio risposta NPS). */
export const FEATURES_NPS_SUBMISSION_SUFFIX = 'submission';
// String utils
export const DASHBOARD = 'dashboard';
export const DARK = 'dark';
export const LIGHT = 'light';
export const IFRAME_ID = 'app-iframe';

export const RQX_HASH_VALUE = 'RQX_HASH_VALUE';
export const RQX_ACTIVE_APPLINK = 'RQX_ACTIVE_APPLINK';

export const HREF = 'href';
export const SAME_TAB = 'sametab';
export const SAME_WINDOW = 'samewindow';
export const NEW_TAB = 'newtab';
export const IFRAME_SRC = 'iframe-src';
/** Prefetch HTML nello shell e injetta con iframe srcdoc (solo se il dump lo richiede esplicitamente). */
export const IFRAME_SRCDOC = 'iframe-srcdoc';
export const SANDBOX =
  'allow-modals allow-top-navigation allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-presentation allow-downloads';

export const SSO_LOCAL_STORAGE_KEY_REALM = 'rqx-sso-realm';
export const SSO_LOCAL_STORAGE_KEY_TOKEN = 'rqx-sso-token';
